
<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h4>Kahve Boyutu Detayı</h4>
      <v-row style="margin-top:100px;">
        <v-col cols="12" md="4">
          <h4>Başlık</h4>
          <v-text-field v-model="coffeeSizeData.coffeeSize" :rules="titleRules" required></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Resim</h4>
          <v-img
            :src="coffeeSizeData.urlPath+coffeeSizeData.coffeeSizeImg+'?x=' + Date.now()"
            alt="asd"
          ></v-img>
          <v-file-input
            show-size
            accept="image/*"
            v-model="coffeeSizeImg"
            label="Resim değiştir"
            required
          ></v-file-input>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Seçili Resim</h4>
          <v-img
            :src="coffeeSizeData.urlPath+coffeeSizeData.coffeeSizeImgSelected+'?x=' + Date.now()"
            alt="asd"
          ></v-img>
          <v-file-input
            show-size
            accept="image/*"
            v-model="coffeeSizeImgSelected"
            label="Resim değiştir"
            required
          ></v-file-input>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Aktif/Pasif</h4>
          <v-checkbox v-model="coffeeSizeData.active"></v-checkbox>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="7">
          <v-btn
            depressed
            color="primary"
            style="text-transform: none !important;float:right;"
            @click="coffeeSizeUpdate()"
          >GÜNCELLE</v-btn>
        </v-col>
      </v-row>

      <!-- <v-row>
          
      </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CoffeeSizeDetails",
  computed: mapGetters(["coffeeSizeData"]),
  methods: {
    ...mapActions(["getCoffeeSize","updateCoffeeSize"]),
    routeCoffeeSizes() {
      this.$router.push("/dashboard/productCategories/coffeeSizes");
    },
    coffeeSizeUpdate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        const promises = [];
       promises.push(this.coffeeSizeObject = {...this.coffeeSizeData});
        if(this.coffeeSizeImg != null && this.coffeeSizeImg!=undefined && !Array.isArray(this.coffeeSizeImg)) {
            console.log("img",this.coffeeSizeImg);
             promises.push(this.getBase64(this.coffeeSizeImg).then(data=>{
         this.coffeeSizeObject.coffeeSizeImg = data;
        }));
        }
        if(this.coffeeSizeImgSelected != null && this.coffeeSizeImgSelected!=undefined && !Array.isArray(this.coffeeSizeImgSelected)) {
        console.log("img",this.coffeeSizeImgSelected);
           promises.push(this.getBase64(this.coffeeSizeImgSelected).then(data=>{
         this.coffeeSizeObject.coffeeSizeImgSelected = data;
        }));
        }

        Promise.all(promises).then(()=>{
            console.log("coffeeSizeObject",this.coffeeSizeObject);
            delete this.coffeeSizeObject.urlPath;
               this.updateCoffeeSize(this.coffeeSizeObject).then(response=>{
          if(response.processStatus == "Success") {
              alert("Güncelleme işlemi başarılıdır");
            this.routeCoffeeSizes();
          }
          else {
              alert("Bir hata oluştu");
          }
        }).catch(err=>{
            alert(err);
        });
        })
      }
    },
getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(',')[1]);
    reader.onerror = error => reject(error);
  });
},
  },
  data: () => ({
    dialog: false,
    valid: true,
    coffeeSizeImg:[],
    coffeeSizeImgSelected:[],
    coffeeSizeObject:{},
    titleRules: [v => !!v || "Başlık alanı zorunludur."],
  }),
  created() {
    let id = this.$route.params.id;

    this.getCoffeeSize(id);
  },
};
</script>
